import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import '../styles/bundle.css';
import QuoteForm from './quoteform.js';
import MaxusView from '../maxus/MaxusView'

import '../styles/fonts.css';
import GlobalStyle from '../styles/globalStyle'

const App = () => {
  return (
    <div>
      {/* <MaxusHeader /> */}
      <Router>
        <GlobalStyle />
        <Switch>
          <Route exact path="/p/:policyId" component={MaxusView} ></Route>
          <Route exact path="/" component={QuoteForm} ></Route>
        </Switch>
      </Router>
    </div>
  );
};

export default App;
